module.exports = __webpack_public_path__ + "img/level-2.4d059112.png";